export const environment = {
  production: true,
  apiUrl: "https://bemol.costabrasil.com.br/apibemol",
  // apiUrl: "http://localhost:5000",
  redirectUrl: "https://bemol.costabrasil.com.br",
  // redirectUrl: "http://localhost:4200",
  clienteId: "3419d0f5-5475-4b67-ab0b-d3bce6f3eaf6",
  tenantId: "34dfd18d-8b28-4a8a-8177-7ced74d3fa88"
};
